import {api} from '../helpers/api';

export const PII_FIELD_RULES_REQUEST = 'PII_FIELD_RULES_REQUEST';
export const PII_FIELD_RULES_SUCCESS = 'PII_FIELD_RULES_SUCCESS';
export const PII_FIELD_RULES_FAILURE = 'PII_FIELD_RULES_FAILURE';

export function piiFieldRulesRequest() {
  return {
    type: PII_FIELD_RULES_REQUEST,
  };
}

export function piiFieldRulesSuccess(payload: $TSFixMe) {
  return {
    type: PII_FIELD_RULES_SUCCESS,
    payload,
  };
}

export function piiFieldRulesFailure(error: $TSFixMe) {
  return {
    type: PII_FIELD_RULES_FAILURE,
    error,
  };
}

export function getPiiFieldRules(countryCode: $TSFixMe) {
  const url = window.REACT_APP_MEMBER_API_HOST + window.REACT_APP_PII_FIELD_RULES_PATH + '?countryCode=' + countryCode;

  const config: FetchConfig = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  };
  return api(url, config, piiFieldRulesRequest(), piiFieldRulesSuccess, piiFieldRulesFailure);
}
